<!-- <p>card-creation works!</p> -->
<!-- <p>{{userid}}</p> -->

<!--
<div class="row" *ngIf="firebaseService.userData as user">
  <div class="col-md-12">
    <div class="media">
      <div class="media-body">
        <h1>Hello: <strong>{{(user.displayName) ? user.displayName : 'Super Admin'}}</strong></h1>
        <p>User ID: <strong>{{user.uid}}</strong></p>
        <p>Email: <strong>{{user.email}}</strong></p>
        <p>Email Verified: <strong>{{user.emailVerified}}</strong></p>
      </div>
    </div>
  </div>
</div> -->

<main id="admin" >
<i (click)="mob_ad_click()" id="mobi" class="bi bi-list mobile-nav-toggle2 d-xl-none"></i>

<header id="header2">
  <div class="d-flex flex-column">

    <div class="profile">
      <img src={{profileurl}} alt="" class="img-fluid rounded-circle">
      <h1 class="text-light"><a href="#">{{(username) ? username : 'Super Admin'}}</a></h1>
      <!-- <div class="social-links mt-3 text-center">
        <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
        <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
        <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
        <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
        <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
      </div> -->
    </div>

    <nav id="navbar2" class="nav-menu2 navbar2">
      <ul>
        <li><a href="/admin#hero2" class="nav-link scrollto active"><i class="bx bx-home"></i> <span>Home</span></a></li>
        <li><a href="/admin#agentapproval" class="nav-link scrollto"><i class="bx bx-user"></i> <span>Agent Approval</span></a></li>
        <li><a href="/admin#cardapproval" class="nav-link scrollto"><i class="bx bx-file-blank"></i> <span>Card Approval</span></a></li>
        <li><a href="/admin#employee" class="nav-link scrollto"><i class="bx bx-book-content"></i> <span>Employee Account CRUD</span></a></li>
        <li><a href="/admin#reports" class="nav-link scrollto"><i class="bx bx-server"></i> <span>Reports</span></a></li>
        <li><a href="#" (click)="loggedout()" class="nav-link scrollto"><i class="bx bx-log-out"></i> <span>Logout</span></a></li>
      </ul>
    </nav><!-- .nav-menu -->
  </div>
</header><!-- End Header -->

<!-- ======= Hero Section ======= -->
<section id="hero2" class="d-flex flex-column justify-content-center align-items-center">
  <div class="hero-container2" data-aos="fade-in">
    <h1>{{username}}</h1>
  </div>
</section>

<section id="agentapproval" class="why-us section-bg">
  <div class="container" data-aos="fade-up">
    <div class="" data-aos="fade-in">
      <div class="section-title">
        <h2>Agents Need To Be Approved</h2>
      </div>
    </div>
    <div class="row">

        <div class="accordion-list" *ngFor="let i of agent_details_appraval_req_main">
          <ul *ngIf="i">
            <li>
              <a data-bs-toggle="collapse" class="collapsed" [attr.data-bs-target]="'#'+appattrname.value">
                <span  class='bx bx-check-double'></span> {{i[0]}} <i class="bx bx-chevron-down icon-show"></i>
                <i class="bx bx-chevron-up icon-close"></i>
              </a>
              <div id={{i[0]}} class="collapse" data-bs-parent=".accordion-list">
                <input type="hidden" #appemail value={{i[1]}}/>
                <input type="hidden" #appattrname value={{i[0]}}/>
                <div class="row">
                  <div class="col"><label>Name:</label></div>
                  <div class="col"><p>{{i[0]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Email</label></div>
                  <div class="col"><p>{{i[1]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Phone No</label></div>
                  <div class="col"><p>{{i[2]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Alt No</label></div>
                  <div class="col"><p>{{i[3]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Aadhar</label></div>
                  <div class="col"><p>{{i[4]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Address</label></div>
                  <div class="col"><p>{{i[5]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Stage</label></div>
                  <div class="col"><p>{{i[6]}}</p></div>
                </div>
                <div class="row">
                  <div class="col">&nbsp;</div>
                <div class="col"><button class="approve-button" (click)="get_approved(appemail.value)">Approve</button>
                  &nbsp;&nbsp;&nbsp;<button class="reject-button" (click)="get_rejected(appemail.value)">Reject</button></div>
              </div>
              </div>
            </li>

          </ul>
        </div>

      </div>

</div>
</section>



<section id="cardapproval" class="why-us section-bg">
  <div class="container-fluid" data-aos="fade-up">
    <div class="container" data-aos="fade-in">
      <div class="section-title">
        <h2>Cards Need To Be Approved</h2>
      </div>
    </div>


    <div class="row">

      <div class="col-lg-12 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1">

        <div class="accordion-list" *ngFor="let i of card_details_appraval_req_main">
          <ul *ngIf="i">
            <li>
              <a data-bs-toggle="collapse" class="collapsed" [attr.data-bs-target]="'#'+appattrcardname.value">
                <span  class='bx bx-check-double'></span> {{i[0]}} <i class="bx bx-chevron-down icon-show"></i>
                <i class="bx bx-chevron-up icon-close"></i>
              </a>
              <div id={{i[0]}} class="collapse" data-bs-parent=".accordion-list">
                <input type="hidden" #appcardemail value={{i[1]}}/>
                <input type="hidden" #appattrcardname value={{i[0]}}/>
                <div class="row">
                  <div class="col"><label>Name:</label></div>
                  <div class="col"><p>{{i[0]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Email</label></div>
                  <div class="col"><a href="/card-details?:user={{i[1]}}" target="none">{{i[1]}}</a></div>
                </div>
                <div class="row">
                  <div class="col"><label>Phone No</label></div>
                  <div class="col"><p>{{i[2]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Reference Code</label></div>
                  <div class="col"><p>{{i[3]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Package</label></div>
                  <div class="col"><p>{{i[4]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Created Date</label></div>
                  <div class="col"><p>{{i[5]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Expiry Date</label></div>
                  <div class="col"><p>{{i[6]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Approval Stage</label></div>
                  <div class="col"><p>{{i[7]}}</p></div>
                </div>
                <div class="row">
                  <div class="col">&nbsp;</div>
                <div class="col"><button class="approve-button" (click)="get_card_approved(appcardemail.value)">Approve</button>
                  &nbsp;&nbsp;&nbsp;<button class="reject-button" (click)="get_card_rejected(appcardemail.value)">Reject</button></div>
              </div>
              </div>
            </li>

          </ul>
        </div>

      </div>

    </div>
</div>
</section>


<section id="employee" class="contact">
  <div class="container" data-aos="fade-up">

    <div class="section-title">
      <h2>Employee Add Form</h2>
    </div>

    <div class="row mt-1">

      <div class="col-lg-12 mt-5 mt-lg-0">

        <form (ngSubmit)="employee_det(employeedetForm.value)" [formGroup]="employeedetForm" class="php-email-form">
          <!-- <div class="row">
            <div class="col-md-6 form-group">
              <input type="file" (change)="selectEmpProfFile($event)" name="profimage" class="form-control" id="profimage" required>
            </div>
            <div class="col-md-3 form-group">
              <button class="btn btn-success" [disabled]="!selectedEmpProfFiles" (click)="upload()">Upload</button>
            </div>
            <div class="col-md-3 form-group">
              <div *ngIf="currentFileEmpProfUpload" class="progress">
                <div class="progress-bar progress-bar-info progress-bar-striped" style="width: 100%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"
                     role="progressbar" attr.aria-valuenow="{{percentageEmpProf}}"
                     aria-valuemin="0" aria-valuemax="100">
                  {{percentageEmpProf}}%
                </div>
              </div>
             </div>

          </div> -->
          <div class="row">
            &nbsp;
          </div>
          <div class="row">
          <div class="col-md-4 form-group">
            <input type="text" name="fname" formControlName="fname" class="form-control" id="fname" placeholder="First Name" required>
          </div>
          <div class="col-md-4 form-group">
            <input type="text" name="mname" formControlName="mname" class="form-control" id="mname" placeholder="Middle Name" required>
          </div>
          <div class="col-md-4 form-group">
            <input type="text" name="lname" formControlName="lname" class="form-control" id="lname" placeholder="Last Name" required>
          </div>
        </div>
          <div class="form-group mt-3">
            <input type="text" class="form-control" name="pord" formControlName="pord" id="pord" placeholder="Position/ Designation" required>
          </div>
          <div class="form-group mt-3">
            <textarea class="form-control" name="address" formControlName="address" rows="5" id="address" placeholder="Address" required></textarea>
          </div>
          <div class="form-group mt-3">
            <input type="text" class="form-control" name="ph" formControlName="ph" id="ph" placeholder="Phone Number" required>
          </div>
          <div class="form-group mt-3">
            <input type="text" class="form-control" name="aph" formControlName="aph" id="aph" placeholder="Alternative Number" required>
          </div>
          <div class="form-group mt-3">
            <input type="text" class="form-control" name="ll" formControlName="ll" id="ll" placeholder="Landline Number" required>
          </div>
          <div class="form-group mt-3">
            <input type="text" class="form-control" name="em" formControlName="em" id="em" placeholder="Email" required>
          </div>
          <div class="form-group mt-3">
            <input type="text" class="form-control" name="wa" formControlName="wa" id="wa" placeholder="Whatsapp Number" required>
          </div>
          <div class="my-3">
            <div class="error-message"></div>
            <div id="emp-succ" class="display_none">Details Saved Successfully. Thank you!</div>
          </div>
          <div class="text-center"><button type="submit">Save</button></div>
        </form>

      </div>

    </div>

  </div>
</section>
<section id="employeeremoval" class="why-us section-bg">
  <div class="container-fluid" data-aos="fade-up">
    <div class="container" data-aos="fade-in">
      <div class="section-title">
        <h2>Employee Removal</h2>
      </div>
    </div>


    <div class="row">

      <div class="col-lg-12 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1">

        <div class="accordion-list" *ngFor="let i of employee_details_main">
          <ul *ngIf="i">
            <li>
              <a data-bs-toggle="collapse" class="collapsed" [attr.data-bs-target]="'#'+appattremployeename.value">
                <span  class='bx bx-check-double'></span> {{i[0]}}  {{i[1]}}  {{i[2]}} <i class="bx bx-chevron-down icon-show"></i>
                <i class="bx bx-chevron-up icon-close"></i>
              </a>
              <div id={{i[0]}} class="collapse" data-bs-parent=".accordion-list">
                <input type="hidden" #appemployeeemail value={{i[8]}}/>
                <input type="hidden" #appattremployeename value={{i[0]}}/>
                <div class="row">
                  <div class="col"><label>First Name:</label></div>
                  <div class="col"><p>{{i[0]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Middle Name:</label></div>
                  <div class="col"><p>{{i[1]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Last Name</label></div>
                  <div class="col"><p>{{i[2]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Designation</label></div>
                  <div class="col"><p>{{i[3]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Address</label></div>
                  <div class="col"><p>{{i[4]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Phone</label></div>
                  <div class="col"><p>{{i[5]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Alternative No</label></div>
                  <div class="col"><p>{{i[6]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Landline</label></div>
                  <div class="col"><p>{{i[7]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Email</label></div>
                  <div class="col"><p>{{i[8]}}</p></div>
                </div>
                <div class="row">
                  <div class="col"><label>Whatsapp</label></div>
                  <div class="col"><p>{{i[9]}}</p></div>
                </div>
                <div class="row">
                  <div class="col">&nbsp;</div>
                  &nbsp;&nbsp;&nbsp;<button class="reject-button" (click)="get_employee_removed(appemployeeemail.value)">Remove</button></div>
              </div>
            </li>

          </ul>
        </div>

      </div>

    </div>
</div>
</section>

<section id="reports" class="why-us section-bg">
  <div class="container-fluid" data-aos="fade-up">
    <div class="container" data-aos="fade-in">
      <div class="section-title">
        <h2>Reports</h2>
      </div>
    </div>


    <div class="row">

      <div class="col-lg-12 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1">
        <div class="row">
          <div class="col">
           <button class="btn-reports"><a href="/today-cards" target="blank" >Today Cards</a></button>
          </div>
          <div class="col">
            <button class="btn-reports"><a href="/today-agents" target="blank"  >Today Agents</a></button>
          </div>
          <div class="col">
            <button class="btn-reports"><a href="/total-cards" target="blank" >Total Cards</a></button>
          </div>
          <div class="col">
            <button class="btn-reports"><a href="/total-agents" target="blank">Total Agents</a></button>
          </div>
        </div>



        <div class="row">
          <div class="col">
            <button class="btn-reports"> <a href="/cards-by-daterange" target="blank" >Cards by Date Range</a></button>
          </div>
          <div class="col">
            <button class="btn-reports"><a href="/paid-cards" target="blank" >Cards Paid</a></button>
          </div>
          <div class="col">
            <button class="btn-reports"><a href="/unpaid-cards" target="blank">Cards Not Paid</a></button>
          </div>
          <div class="col">
            <button class="btn-reports"><a href="/cards-expiry-tomorrow" target="blank">Cards Expiry Tomorrow</a></button>
          </div>
        </div>



      </div>

    </div>
</div>
</section>
</main>
